import CollapsibleHeaderContent from './CollapsibleHeaderContent';

export default CollapsibleHeaderContent;
